// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"346":"b6ab9ccdbf7c980009ba","620":"ef126eca67d334e7d4bf"}[chunkId] + ".js";
};